import React from "react";
import { Typography, Stack, Box, Divider } from "digiwash-components";

import useTransactionsList from "../../ducks/user/hooks/useTransactionsList";
import RowTransaction from "../../components/RowTransaction";
import Loading from "../../components/Loading";
import { TransactionsType } from "../../types/server";

function TransactionsCard() {
  let { data, isValidating, error } = useTransactionsList();
  return (
    <>
      {isValidating && (
        <Stack distribution="center" direction="vertical">
          <Divider size="m" />
          <Loading color="primary.main" />
        </Stack>
      )}
      {!isValidating && error ? (
        <Stack distribution="center" direction="vertical">
          <Divider size="m" />
          <Typography>{error}</Typography>
        </Stack>
      ) : null}
      <Divider size="l" />
      {!isValidating && data
        ? data.map((transaction: TransactionsType) => (
            <RowTransaction data={transaction} />
          ))
        : null}
      {!isValidating && data && data.length === 0 && (
        <Box p="m">
          <Typography color="neutrals.700" ff="mainBold" alignment="center">
            تراکنشی ثبت نشده است
          </Typography>
        </Box>
      )}
    </>
  );
}

export default TransactionsCard;
